import React, { useState, useEffect } from "react";
import "./HotelWebsite3.css";

const HotelWebsite3 = () => {
  const [filter, setFilter] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState(null);

  // --- 30 LUXURY PROPERTIES ---
  const hotelList = [
    { id: 1, name: "Aman Tokyo", loc: "Tokyo, Japan", price: "95,000", tag: "Zen", img: "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?auto=format&fit=crop&w=1200", amenities: ["Spa", "Minimalist", "City View"] },
    { id: 2, name: "Soneva Jani", loc: "Maldives", price: "1,20,000", tag: "Water", img: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?auto=format&fit=crop&w=1200", amenities: ["Overwater", "Slides", "Cinema"] },
    { id: 3, name: "Hotel du Cap-Eden-Roc", loc: "Antibes, France", price: "85,000", tag: "Heritage", img: "https://images.unsplash.com/photo-1564501049412-61c2a3083791?auto=format&fit=crop&w=1200", amenities: ["Infinity Pool", "Private Cabana"] },
    { id: 4, name: "The Silo Hotel", loc: "Cape Town", price: "45,000", tag: "Art", img: "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?auto=format&fit=crop&w=1200", amenities: ["Museum", "Rooftop Pool"] },
    { id: 5, name: "Six Senses Ibiza", loc: "Spain", price: "55,000", tag: "Wellness", img: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=1200", amenities: ["Yoga", "Organic Food", "Beach"] },
    { id: 6, name: "Belmond Hotel Caruso", loc: "Ravello, Italy", price: "72,000", tag: "Heritage", img: "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?auto=format&fit=crop&w=1200", amenities: ["Gardens", "Cliffside"] },
    { id: 7, name: "Burj Al Arab Jumeirah", loc: "Dubai", price: "1,50,000", tag: "Luxury", img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1200", amenities: ["Butler", "Underwater Rest."] },
    { id: 8, name: "Amangiri", loc: "Utah, USA", price: "1,10,000", tag: "Desert", img: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?auto=format&fit=crop&w=1200", amenities: ["Canyon", "Spa", "Silence"] },
    { id: 9, name: "Nihi Sumba", loc: "Indonesia", price: "68,000", tag: "Wellness", img: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=1200", amenities: ["Surfing", "Private Villas"] },
    { id: 10, name: "Badrutt's Palace", loc: "St. Moritz", price: "78,000", tag: "Alpine", img: "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?auto=format&fit=crop&w=1200", amenities: ["Ski", "Historic", "Champagne"] },
    { id: 11, name: "The Plaza", loc: "New York", price: "50,000", tag: "Luxury", img: "https://images.unsplash.com/photo-1444201983204-c43cbd584d93?auto=format&fit=crop&w=1200", amenities: ["Central Park", "Gold Decor"] },
    { id: 12, name: "Jade Mountain", loc: "St. Lucia", price: "92,000", tag: "Water", img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1200", amenities: ["Open Wall", "Private Pool"] },
    { id: 13, name: "Ritz Paris", loc: "France", price: "1,15,000", tag: "Heritage", img: "https://images.unsplash.com/photo-1499856871940-a09627c6d7db?auto=format&fit=crop&w=1200", amenities: ["Chanel Spa", "Fine Dining"] },
    { id: 14, name: "Cliveden House", loc: "Berkshire, UK", price: "48,000", tag: "Heritage", img: "https://images.unsplash.com/photo-1518780664697-55e3ad937233?auto=format&fit=crop&w=1200", amenities: ["Palatial", "Private Yacht"] },
    { id: 15, name: "Post Ranch Inn", loc: "Big Sur, USA", price: "88,000", tag: "Zen", img: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=1200", amenities: ["Treehouses", "Cliff Edge"] },
    { id: 16, name: "The Brando", loc: "French Polynesia", price: "1,80,000", tag: "Water", img: "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?auto=format&fit=crop&w=1200", amenities: ["Private Island", "Eco"] },
    { id: 17, name: "Marina Bay Sands", loc: "Singapore", price: "35,000", tag: "Luxury", img: "https://images.unsplash.com/photo-1525625239514-75b4b93109b1?auto=format&fit=crop&w=1200", amenities: ["Infinity Pool", "Casino"] },
    { id: 18, name: "Giraffe Manor", loc: "Kenya", price: "60,000", tag: "Wellness", img: "https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=1200", amenities: ["Wildlife", "Breakfast"] },
    { id: 19, name: "Singita Ebony", loc: "South Africa", price: "1,40,000", tag: "Desert", img: "https://images.unsplash.com/photo-1493246318656-5bbd4afb293c?auto=format&fit=crop&w=1200", amenities: ["Safari", "Plunge Pool"] },
    { id: 20, name: "The Reverie Saigon", loc: "Vietnam", price: "28,000", tag: "Art", img: "https://images.unsplash.com/photo-1528127220108-1558304b4b3c?auto=format&fit=crop&w=1200", amenities: ["Italian Design", "City Spa"] },
    { id: 21, name: "La Mamounia", loc: "Marrakech", price: "58,000", tag: "Heritage", img: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1200", amenities: ["Royal", "Garden"] },
    { id: 22, name: "Atlantis The Royal", loc: "Dubai", price: "98,000", tag: "Luxury", img: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=1200", amenities: ["Private Pools", "Nightlife"] },
    { id: 23, name: "Oberoi Udaivilas", loc: "Udaipur, India", price: "45,000", tag: "Heritage", img: "https://images.unsplash.com/photo-1599661046289-e31897846e41?auto=format&fit=crop&w=1200", amenities: ["Lakefront", "Palace"] },
    { id: 24, name: "Como Shambhala", loc: "Bali", price: "52,000", tag: "Zen", img: "https://images.unsplash.com/photo-1559628233-41aef2a24c28?auto=format&fit=crop&w=1200", amenities: ["Healing", "Ayurveda"] },
    { id: 25, name: "Park Hyatt", location: "Sydney", price: "42,000", tag: "Art", img: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?auto=format&fit=crop&w=1200", amenities: ["Opera View", "Concierge"] },
    { id: 26, name: "Adare Manor", loc: "Ireland", price: "64,000", tag: "Alpine", img: "https://images.unsplash.com/photo-1518780664697-55e3ad937233?auto=format&fit=crop&w=1200", amenities: ["Golf", "Falconry"] },
    { id: 27, name: "Rosewood", loc: "Phuket", price: "55,000", tag: "Water", img: "https://images.unsplash.com/photo-1583037189850-1921ae7c6c22?auto=format&fit=crop&w=1200", amenities: ["Beachfront", "Eco"] },
    { id: 28, name: "The Peninsula", loc: "Hong Kong", price: "48,000", tag: "Luxury", img: "https://images.unsplash.com/photo-1541432901042-2d8bd64b4a6b?auto=format&fit=crop&w=1200", amenities: ["Rolls Royce", "Tradition"] },
    { id: 29, name: "Explora Patagonia", loc: "Chile", price: "62,000", tag: "Wellness", img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1200", amenities: ["Glacier", "Guide"] },
    { id: 30, name: "Mandarin Oriental", loc: "Lake Como", price: "82,000", tag: "Water", img: "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?auto=format&fit=crop&w=1200", amenities: ["Floating Pool", "Boats"] },
  ];

  const tags = ["All", "Luxury", "Heritage", "Water", "Zen", "Wellness", "Alpine", "Desert"];

  const filtered = hotelList.filter(h => 
    (filter === "All" || h.tag === filter) &&
    (h.name.toLowerCase().includes(searchTerm.toLowerCase()) || h.loc.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleEnquiry = (hotel) => {
    setSelectedHotel(hotel);
    setIsModalOpen(true);
  };

  return (
    <div className="hotelwebsite3-container">
      {/* NAVIGATION */}
      <nav className="hotelwebsite3-navbar">
        <div className="hotelwebsite3-logo">ZOTRAI</div>
        <div className="hotelwebsite3-nav-links">
            <a href="#discover">Discover</a>
            <a href="#collections">HOTELS</a>
            <button className="hotelwebsite3-btn-gold" onClick={() => handleEnquiry(null)}>Book with us</button>
        </div>
      </nav>

      {/* HERO SECTION */}
      <section className="hotelwebsite3-hero">
        <div className="hotelwebsite3-hero-content">
          <h1 className="hotelwebsite3-fade-in">The Art of <br/><span>Hospitality</span></h1>
          <p style={{color: "white"}}>Curating the world’s most profound living spaces.</p>
        </div>

        {/* Floating Booking Widget */}
        <div className="hotelwebsite3-booking-widget">
          <div className="hotelwebsite3-input-box">
            <label>Destination</label>
            <input type="text" placeholder="Where to?" onChange={(e) => setSearchTerm(e.target.value)} />
          </div>
          <div className="hotelwebsite3-input-box">
            <label>Dates</label>
            <input type="text" placeholder="Jan 12 - Jan 20" readOnly />
          </div>
          <div className="hotelwebsite3-input-box">
            <label>Guests</label>
            <input type="text" placeholder="2 Guests" readOnly />
          </div>
          <button className="hotelwebsite3-search-cta" onClick={() => document.getElementById('collections').scrollIntoView()}>Explore</button>
        </div>
      </section>

      {/* FILTER TABS */}
      <div className="hotelwebsite3-filter-bar">
        {tags.map(t => (
          <button 
            key={t} 
            className={`hotelwebsite3-tag-btn ${filter === t ? 'active' : ''}`}
            onClick={() => setFilter(t)}
          >
            {t}
          </button>
        ))}
      </div>

      {/* MAIN LISTING */}
      <section id="collections" className="hotelwebsite3-section">
        <div className="hotelwebsite3-grid">
          {filtered.map((hotel) => (
            <div className="hotelwebsite3-card" key={hotel.id}>
              <div className="hotelwebsite3-card-image">
                <img src={hotel.img} alt={hotel.name} />
                <div className="hotelwebsite3-card-badge">{hotel.tag}</div>
              </div>
              <div className="hotelwebsite3-card-details">
                <div className="hotelwebsite3-card-header">
                  <h3>{hotel.name}</h3>
                  <span className="hotelwebsite3-price">₹{hotel.price} <small>/ Night</small></span>
                </div>
                <p className="hotelwebsite3-loc">📍 {hotel.loc}</p>
                <div className="hotelwebsite3-amenity-pills">
                  {hotel.amenities.map(a => <span key={a}>{a}</span>)}
                </div>
                <button className="hotelwebsite3-reserve-btn" onClick={() => handleEnquiry(hotel)}>Request Reservation</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* MODAL / ENQUIRY */}
      {isModalOpen && (
        <div className="hotelwebsite3-modal-overlay">
          <div className="hotelwebsite3-modal">
            <button className="hotelwebsite3-modal-close" onClick={() => setIsModalOpen(false)}>✕</button>
            <div className="hotelwebsite3-modal-body">
              <h2>Reservation Request</h2>
              {selectedHotel && <p className="selected-tag">Applying for: <strong>{selectedHotel.name}</strong></p>}
              <form className="hotelwebsite3-form" onSubmit={(e) => {e.preventDefault(); alert("Enquiry Sent!"); setIsModalOpen(false)}}>
                <div className="form-row">
                  <div className="form-group"><label>Name</label><input type="text" required /></div>
                  <div className="form-group"><label>Email</label><input type="email" required /></div>
                </div>
                <div className="form-group"><label>Contact Number</label><input type="tel" required /></div>
                <div className="form-group"><label>Details / Special Requests</label><textarea rows="4"></textarea></div>
                <button type="submit" className="hotelwebsite3-form-btn">Submit Enquiry</button>
              </form>
            </div>
          </div>
        </div>
      )}

      <footer className="hotelwebsite3-footer">
        <p>© 2025 Zotrai Luxury Hospitality Group. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default HotelWebsite3;